import React, { useState, useEffect } from "react";
import { useJwt } from "react-jwt";
import { useLocation } from 'react-router-dom';

import { authService } from "../services/auth";

// high level component, wraps most of app
// passes auth params to children components
// upon state changes, re-assesses expiration of access token
const Authentication = ({children}) => {
  const location = useLocation();
  // state
  const [ accessToken, setAccessToken ] = useState(localStorage.getItem('accessToken'));
  const { isExpired } = useJwt(localStorage.getItem('accessToken'));

  // effects
  useEffect(() => {
    if (accessToken && isExpired){
      authService.refreshToken((newToken) => {
        setAccessToken(newToken)
      }, () => {
        // this means the refresh token is expired. take user to /login/ to re-authenticate
        console.error("couldnt refresh token")
        window.location = `/login/?next=${window.location.pathname}`
      });
    }
  }, [
    accessToken,
    isExpired,
  ]); // If current token is expired, go refresh it

  useEffect(() => {
    if (accessToken && !isExpired){
      authService.fetchUser();
    }
  }, [
    accessToken,
    isExpired,
  ]); // Refetches user config when a new access token is set

  
  // clean slate of props we return to all components
  var authState = {
    'authenticated': false,
    'accessToken': null,
    'refreshToken': null,
    'refreshingToken': false,
    'currentUser': null,
    'location': location,
  }

  // determine returning properties based on state of current token
  if (accessToken && !isExpired){
    // we're ready to rock!
    authState = Object.assign(authState, {
      'authenticated': true,
      'accessToken': localStorage.getItem('accessToken'),
      'refreshToken': localStorage.getItem('refreshToken'),
      'currentUser': JSON.parse(localStorage.getItem('currentUser')),
    })
  } else if (accessToken && isExpired) {
    // it's expired. the effect in this file will get a new one
    authState = Object.assign(authState, {
      'refreshingToken': true,
    })
    return '';  // show a blank screen temporarily
  } else {
    // not authenticated. this is an OK state depending on which route it is
    // screens like /account/ + /tests/ will kick out to login,
    // while screens like /login/ + /register/ are fine 
  }

  return (
    <React.Fragment>
      {children({
        ...authState,
      })}
    </React.Fragment>
  )
};

export default Authentication;

